import { Form, Input } from 'antd';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

export const UsernameFormItem = () => {
    return (
        <section style={{ width: '100%', marginTop: 24 }}>
            <div style={{ marginBottom: 16 }} className="label">
                メールアドレスを入力してください。
            </div>
            <Form.Item
                required={false}
                className="input-font-style label-form-style "
                name="username"
                label={false}
                rules={[
                    {
                        required: true,
                        type: 'email',
                        message: getMessage('Mail_Invalid'),
                    },
                ]}
            >
                <Input style={{ width: '100%' }} placeholder={PLACEHOLDER.EMAIL} maxLength={100} />
            </Form.Item>
        </section>
    );
};
